var map = {
	"./cs-CZ.json": 134,
	"./da-DK.json": 135,
	"./en-CA.json": 136,
	"./en-GB.json": 137,
	"./fr-FR.json": 138,
	"./hu-HU.json": 139,
	"./id-ID.json": 140,
	"./ja-JP.json": 141,
	"./lv-LV.json": 142,
	"./nl-NL.json": 143,
	"./pl-PL.json": 144,
	"./pt-PT.json": 145,
	"./sk-SK.json": 146,
	"./zh-CN.json": 147,
	"./zh-TW.json": 148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;